module.exports = __webpack_public_path__ + "img/opera.81fe7633.svg";